import { stringify } from 'qs';
import Bugsnag from 'bugsnag-js';

// eslint-disable-next-line import/no-unresolved
import runtimeConfig from 'runtimeConfig.json';

/**
 * Build a URL to Case Classic for the given path and company ID ("Dealer ID").
 * @param {string} path The Case Classic endpoint to target (without a leading `/`)
 * @param {string} companyId The current dealer ID from the user profile
 * @param {string} tenant The current tenant/OEM
 * @returns {string} The full URL to Case Classic, with params
 */

function buildHybridLink(path, companyId, tenant) {
  if (!tenant) {
    const errorMsg = 'No tenant available for hybrid link';
    console.error(errorMsg);
    Bugsnag.notify('hybrid link error', errorMsg, null, 'error');
    return '/';
  }

  const envVar = `${tenant.toUpperCase()}_PRICING_URL`;
  const baseUrl = process.env[envVar];
  if (!baseUrl) {
    const errorMsg = `
      Cannot find pricing URL for tenant '${tenant}' - missing environment variable '${envVar}'
    `;
    console.error(errorMsg);
    Bugsnag.notify('hybrid link error', errorMsg, { tenant }, 'error');
    return '/';
  }

  const params = {
    dealer_id: companyId,
    return_path: window.location.pathname,
    return_app: runtimeConfig.hybrid_link.return_app,
  };

  const queryString = stringify(params);
  return `${baseUrl}/${path}?${queryString}`;
}

/**
 * Build a URL to the asset detail page on Case Classic.
 * @param {string} assetId the id of the asset being linked to
 * @param {object} options an object containing required values for building the URL
 * @property {string} options.companyId the user's companyId
 * @property {string} options.tenant the tenant connected to this user
 * @returns {string} The full URL to the asset detail page, with params
 */
export function buildAssetDetailLink(assetId, { companyId, tenant }) {
  return buildHybridLink(`fleet/vehicles/${assetId}`, companyId, tenant);
}

/**
 * Build a URL to the Fleet Admin page on Case Classic.
 * @param {object} options an object containing required values for building the URL
 * @param {string} options.companyId The current dealer ID from the user profile
 * @property {string} options.tenant the tenant connected to this user
 * @returns {string} The full URL to the fleet admin page, with params
 */
// Eventually there will be other hybrid links, but until then...
export function buildFleetAdminLink({ companyId, tenant }) {
  return buildHybridLink('fleet/admin', companyId, tenant);
}



// WEBPACK FOOTER //
// ./utils/hybridLinks.js